<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d)">
<rect x="10" y="6" width="40" height="40" rx="20" fill="#9B9BCE"/>
</g>
<path d="M36.0433 17H23.9168C22.3185 17 21 18.3185 21 19.9367V27.8479C21 29.4662 22.3185 30.7647 23.9168 30.7647H29.6104L35.7836 34.4206L35.4839 30.7647H36.0633C37.6815 30.7647 39 29.4462 39 27.8479V19.9367C38.98 18.3185 37.6615 17 36.0433 17Z" fill="white" fill-opacity="0.9"/>
<rect x="24.3181" y="21.1479" width="10.7842" height="1.65911" rx="0.829554" fill="#BFBFDF"/>
<rect x="24.3181" y="24.4661" width="10.7842" height="1.65911" rx="0.829554" fill="#BFBFDF"/>
<defs>
<filter id="filter0_d" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>
